<template>
  <div :class="classes" />
</template>

<script lang="ts">
import {
  Component,
  Inject,
  Prop,
  Vue,
  toNative,
} from '~/utility/pu-class-decorator'
import {
  PitchtypeMiniAvailabilityCalendarDayWithStatusesInfo,
  PitchtypeMiniAvailabilityCalendarStayDates,
} from '../schemas'

@Component
class PitchtypeMiniAvailabilityCalendarDay extends Vue {
  @Prop({ required: true })
  day: PitchtypeMiniAvailabilityCalendarDayWithStatusesInfo

  @Inject('stayDates')
  stayDates?: PitchtypeMiniAvailabilityCalendarStayDates

  get classes() {
    if (!this.day) {
      return 'day skipped'
    }

    return this.stayDates?.start && this.stayDates?.end
      ? {
          ...this.defaultClasses,
          'no-arrivals': this.day.noArrivals,
          'has-availability': this.day.isAvailable,
          selected: this.day.selected,
        }
      : this.defaultClasses
  }

  private get defaultClasses() {
    return {
      day: true,
      weekend: this.day.isWeekend,
      sunday: this.day.isSunday,
      'is-past': this.day.isPast,
      'has-availability': this.day.hasAvailability,
    }
  }
}

export default toNative(PitchtypeMiniAvailabilityCalendarDay)
</script>

<style scoped>
.day {
  width: 6px;
  height: 6px;
  margin-bottom: 1px;
  background-color: var(--colour-page-background);
}

.has-availability {
  background-color: var(--colour-light-green);
  border-color: var(--colour-light-green);
}

.day.selected {
  background-color: var(--colour-dark-blue);
  border-color: var(--colour-dark-blue);
}

.skipped {
  background-color: transparent !important;
}
</style>
